{
  "seo": {
    "title": "My Badges",
    "description": "Celebrate learning achievements with CuriPop badges."
  },
  "loading": "Loading badges…",
  "noChild": {
    "title": "Badges are for kid profiles",
    "subtitle": "Switch to a child profile to see badges."
  },
  "title": "My Badges",
  "subtitle": "Keep exploring to unlock more rewards.",
  "empty": "No badges yet. Start exploring questions to earn your first one."
}
